import * as setup from '@/setup';
import Title from '@/objects/title';
import Counter from '@/objects/counter';
import Letter from '@/objects/letter';
import runtime from '@/runtime';
import { formatDitloideTitle } from '@/utils/ditloide';

export var drawGameScene = (scene, leftMargin, ditloide) => {
	// aggiungi sfondo
	scene.add
		.image(scene.sys.game.config.width / 2, scene.sys.game.config.height / 2, 'background')
		.setOrigin(0.5, 0.5);

	// aggiungi lo sfondo del logo
	let graphics = scene.add.graphics();
	graphics.lineStyle(setup.styles.backgroundLogo.style);
	graphics.fillStyle(setup.styles.backgroundLogo.style.color);
	graphics.fillRect(0, 0, scene.sys.game.config.width, setup.styles.backgroundLogo.height);

	// piazza il logo al centro dello sfondo
	scene.add
		.image(scene.sys.game.config.width / 2, setup.styles.backgroundLogo.height / 2, 'logo')
		.setOrigin(0.5, 0.5)
		.setScale(0.5);

	// aggiungi bottone l'help
	let helpButton = scene.add
		.image(0, 0, 'help')
		.setOrigin(0.5)
		.setAlpha(setup.various.helpButton.alpha)
		.setScale(0.7)
		.setInteractive({ useHandCursor: true });
	helpButton.x = scene.sys.game.config.width - helpButton.displayWidth / 2 - 10;
	helpButton.y = setup.styles.backgroundLogo.height / 2;

	// aggiungi bottone menu a sinistra (stesse dimensioni del bottone help)
	let menuButton = scene.add
		.image(0, 0, 'menu')
		.setOrigin(0.5)
		.setAlpha(setup.various.helpButton.alpha)
		.setScale(0.7)
		.setInteractive({ useHandCursor: true });
	menuButton.x = menuButton.displayWidth / 2 + 10;
	menuButton.y = setup.styles.backgroundLogo.height / 2;

	// aggiungi lo sfondo del ditloide
	let graphicsDitl = scene.add.graphics();
	graphicsDitl.lineStyle(setup.styles.backgroundDitloide.style);
	graphicsDitl.fillStyle(setup.styles.backgroundDitloide.style.color);
	graphicsDitl.fillRect(
		0,
		setup.styles.backgroundLogo.height,
		scene.sys.game.config.width,
		setup.styles.backgroundDitloide.height
	);
	graphicsDitl.setAlpha(0.2);

	// mostra il ditloide poco sotto il logo con punti dopo le lettere
	var formattedDitloide = formatDitloideTitle(ditloide);
	let let_style = setup.styles.colorLetterStyle;
	if (formattedDitloide.length > 40) {
		// Titoli molto lunghi: font ridotto e letter-spacing negativo
		let_style = setup.styles.colorLetterStyleXMin;
	} else if (formattedDitloide.length > 25) {
		let_style = setup.styles.colorLetterStyleMin;
	}

	let ditloide_title = new Title(
		scene,
		scene.sys.game.config.width / 2,
		setup.styles.backgroundLogo.height + setup.margin.ditloideMarginTop,
		formattedDitloide,
		let_style,
	).setOrigin(0.5);


	// crea un oggetto clock e lo posiziona
	let clockCounter = new Counter(scene, 0, 0, 'clock', runtime.mode.available_time);
	clockCounter.x += clockCounter.getBounds().width / 3 + leftMargin;
	clockCounter.y += scene.sys.game.config.height - clockCounter.getBounds().height / 2;

	// crea un oggetto superpoteri e lo posiziona
	let powerCounter = new Counter(scene, 0, 0, 'power', runtime.ranking.available_credits);
	powerCounter.x += scene.sys.game.config.width / 2;
	powerCounter.y += scene.sys.game.config.height - powerCounter.getBounds().height / 2;

	// crea un oggetto score e lo posiziona
	let scoreCounter = new Counter(scene, 0, 0, 'score', runtime.round.score);
	scoreCounter.x += scene.sys.game.config.width - (clockCounter.getBounds().width / 3 + leftMargin);
	scoreCounter.y += scene.sys.game.config.height - scoreCounter.getBounds().height / 2;
	return {helpButton, menuButton, clockCounter, powerCounter, scoreCounter};
};

/************************************************
 *
 *  Disegno del tavolo da gioco 10x8
 *
 *************************************************/
export var drawGameBoard = (scene, leftMargin, solutionArray, schemaArray) => {
	let boardBoxes = scene.add.group({
		key: 'letter-gray-light',
		repeat: setup.box.repeat - 1, //attenzione va messo uno in meno
		setScale: {x: setup.box.scale, y: setup.box.scale},
		createCallback: function (obj) {
			let id = this.getLength() - 1;
			// assegno un valore custom alle celle. Tale valore è un oggetto con id e char che assume tre stati: false, spazio o carattere in base alla soluzione
			obj.datas = {id: id, char: false};
			obj.datas.char = schemaArray[id];
			if (schemaArray[id] === false || !schemaArray[id]) {
				// è una casella separatrice, non interattiva. Assegno un colore diverso
				obj.setTint(setup.colors.letterDisabled);
			} else if (schemaArray[id] === ' ') {
				// è una casella da risolvere, le uniche interattive
				obj.setInteractive();
			}
		}
	});

	// Allineo la griglia 10x8 delle caselle
	Phaser.Actions.GridAlign(boardBoxes.getChildren(), {
		width: setup.box.rows,
		height: setup.box.cols,
		cellWidth: setup.box.width,
		cellHeight: setup.box.height,
		x: leftMargin,
		y: setup.styles.backgroundLogo.height + setup.styles.backgroundDitloide.height + setup.box.height / 2
	});

	// inizializzo le variabile per il ciclo
	let i = 0;
	let boardLetters = [];

	// Disegno le lettere sullo schema e trovo la posizione del cursore alla prima lettera vuota disponibile
	Phaser.Actions.Call(boardBoxes.getChildren(), function (cell) {
		if (cell.datas.char && cell.datas.char !== ' ') {
			// è una casella con una lettera
			boardLetters[i] = new Letter(cell.scene, cell.x, cell.y, schemaArray[i]).setOrigin(0.5, 0.5);
		}

		// Assegno tutte le lettere della soluzione
		if (solutionArray[i])
			cell.datas.solution = solutionArray[i];

		i++;
	});

	//console.log('boardBoxes', boardBoxes);
	//console.log('boardLetters', boardLetters);
	return {boardBoxes, boardLetters};
};

export var drawPlayerBoard = (scene, leftMargin, gridPlayerBoxesCoord, uniqLetters) => {
	let playerBoxes = scene.add.group({
		key: 'letter-gray-light',
		repeat: setup.various.letterRepeat - 1, //attenzione va messo uno in meno
		setScale: {x: setup.box.scale, y: setup.box.scale},
		createCallback: function (obj) {
			// di default le caselle non sono interattive
			obj.setTint(setup.colors.letter);
			obj.datas = {id: this.getLength() - 1, char: ''};
		}
	});

	Phaser.Actions.GridAlign(playerBoxes.getChildren(), {
		width: setup.box.rows,
		height: 2,
		cellWidth: setup.box.width,
		cellHeight: setup.box.height,
		x: leftMargin,
		y: gridPlayerBoxesCoord.y
	});

	// Posiziono il testo della lettera nel gruppo di celle apposito
	let i = 0;
	let playerLetters = [];
	Phaser.Actions.Call(
		playerBoxes.getChildren(),
		function (cell) {
			// solo per le caselle che sono definite aggiungo all'array globale, le rendo interattive e assegno la lettera
			if (uniqLetters[i]) {
				playerLetters.push(new Letter(scene, cell.x, cell.y, uniqLetters[i]).setOrigin(0.5, 0.5));
				cell.datas.char = uniqLetters[i];
				cell.setInteractive();
				// tutte le lettere del giocatore si mettono in ascolto sull'evento playOnLetter
				/*
				 cell.on('playOneLetter', scene.playOnLetter, self);
				 cell.on('pointerup', function() {
				 // click su una casella del giocatore emetto l'evento playOneLetter
				 scene.emit('playOneLetter', this);
				 });
				 cell.on('pointerover', function() {
				 scene.setTint(setup.colors.letterOver);
				 });
				 cell.on('pointerout', function() {
				 scene.setTint(setup.colors.letter);
				 });*/
			}
			i++;
		},
		scene
		);
	return {playerBoxes, playerLetters};
};

export var drawSuperPower = (scene, gridPlayerBoxesCoord) => {
	// Aggiungi menu superpower
	// piazza al logo al centro dello sfondo
	let superPowerMenu = scene.add
		.image(
			scene.sys.game.config.width / 2,
			gridPlayerBoxesCoord.y + 2 * setup.box.height + setup.margin.lettersMarginTop,
			'superpower-menu'
			)
		.setScale(0.89);
	superPowerMenu.y += superPowerMenu.height / 6 + setup.margin.lettersMarginTop;

	// disegno titolo superPower
	let titleHelp = new Title(
		scene,
		scene.sys.game.config.width / 2,
		superPowerMenu.y - superPowerMenu.y / 18 + setup.margin.superpowerMarginTop,
		setup.labels.superpower,
		setup.styles.superpowerTitleStyle
		).setOrigin(0.5);

	scene.add
		.image(
			scene.sys.game.config.width / 2 - titleHelp.width / 2 - 20,
			superPowerMenu.y - superPowerMenu.y / 18 + setup.margin.superpowerMarginTop + 5,
			'power-icon'
			)
		.setScale(0.15);

	// Stile ridotto per i bottoni degli aiuti per evitare sovrapposizioni
	const reducedSuperpowerStyle = {
		...setup.styles.superpowerStyle,
		fontSize: 35  // Ridotto da 45 a 35
	};

	// Primo aiuto: Svela (rivelare casella corrente) - posizionato a sinistra
	let revealCurrentPower = new Title(
		scene,
		scene.sys.game.config.width / 5,
		superPowerMenu.y + 15,
		runtime.statuses.superpower[runtime.constants.superpower.MOTIVE_REVEAL_CURRENT],
		reducedSuperpowerStyle,
		setup.styles.superpowerShadowStyle
		)
		.setOrigin(0.5)
		.setInteractive();
	revealCurrentPower._type = runtime.constants.superpower.MOTIVE_REVEAL_CURRENT;

	// Secondo aiuto: Consonante
	let consonantPower = new Title(
		scene,
		scene.sys.game.config.width * 2 / 5,
		superPowerMenu.y + 15,
		runtime.statuses.superpower[runtime.constants.superpower.MOTIVE_CONSONANT],
		reducedSuperpowerStyle,
		setup.styles.superpowerShadowStyle
		)
		.setOrigin(0.5)
		.setInteractive();
	consonantPower._type = runtime.constants.superpower.MOTIVE_CONSONANT;

	// Terzo aiuto: Vocale
	let vowelPower = new Title(
		scene,
		scene.sys.game.config.width * 3 / 5,
		superPowerMenu.y + 15,
		runtime.statuses.superpower[runtime.constants.superpower.MOTIVE_VOWEL],
		reducedSuperpowerStyle,
		setup.styles.superpowerShadowStyle
		)
		.setOrigin(0.5)
		.setInteractive();
	vowelPower._type = runtime.constants.superpower.MOTIVE_VOWEL;

	// Quarto aiuto: Parola
	let wordPower = new Title(
		scene,
		scene.sys.game.config.width * 4 / 5,
		superPowerMenu.y + 15,
		runtime.statuses.superpower[runtime.constants.superpower.MOTIVE_WORD],
		reducedSuperpowerStyle,
		setup.styles.superpowerShadowStyle
		)
		.setOrigin(0.5)
		.setInteractive();
	wordPower._type = runtime.constants.superpower.MOTIVE_WORD;

	// Aggiungi separatori verticali tra i bottoni degli aiuti
	const separatorY = superPowerMenu.y + 20;
	const separatorHeight = 50;
	const separatorColor = 0x808080; // Grigio

	// Separatore tra Svela e Consonante
	let separator1 = scene.add.graphics();
	separator1.lineStyle(1, separatorColor, 1);
	separator1.beginPath();
	separator1.moveTo(scene.sys.game.config.width * 1.44 / 5, separatorY - separatorHeight / 2);
	separator1.lineTo(scene.sys.game.config.width * 1.44 / 5, separatorY + separatorHeight / 2);
	separator1.strokePath();

	// Separatore tra Consonante e Vocale
	let separator2 = scene.add.graphics();
	separator2.lineStyle(1, separatorColor, 1);
	separator2.beginPath();
	separator2.moveTo(scene.sys.game.config.width * 2.55 / 5, separatorY - separatorHeight / 2);
	separator2.lineTo(scene.sys.game.config.width * 2.55 / 5, separatorY + separatorHeight / 2);
	separator2.strokePath();

	// Separatore tra Vocale e Parola
	let separator3 = scene.add.graphics();
	separator3.lineStyle(1, separatorColor, 1);
	separator3.beginPath();
	separator3.moveTo(scene.sys.game.config.width * 3.5 / 5, separatorY - separatorHeight / 2);
	separator3.lineTo(scene.sys.game.config.width * 3.5 / 5, separatorY + separatorHeight / 2);
	separator3.strokePath();

	let superPowerButtons = new Phaser.GameObjects.Group(scene, [revealCurrentPower, consonantPower, vowelPower, wordPower]);
	return {superPowerButtons};
};
